import Immutable from 'immutable'
import { types } from 'store/actions/courses'

const initialState = Immutable.fromJS({
  pending: false,
  dateLoaded: undefined,
  errors: new Immutable.List(),
})

export default function courseReducer(state = initialState, action) {
  let ret = state
  const { type, payload } = action
  switch(type) {
    case `${types.GET_DETAILS}_PENDING`: {
      ret = ret.set('pending', true)
      break
    }
    case `${types.GET_DETAILS}_REJECTED`: {
      const errorObj = {
        message: payload.message,
        date: new Date(),
      }
      try {
        errorObj.responseCode = payload.response.status
      } catch(_err) {
        //pass
      }
      ret = ret.set('pending', false)
        .set('dateLoaded', new Date())
        .update('errors', errors => errors.unshift(errorObj))
      break
    }
    case `${types.GET_DETAILS}_FULFILLED`: {
      ret = ret.set('pending', false)
        .set('dateLoaded', new Date())
        .update('errors', errors => errors.clear())
      break
    }
    default:
      // no default
  }
  return ret
}
